import ThemedSkeleton from "../../ui/ThemedSkeleton";
import { useGetBusinessProfile } from "../business_profile/useGetBusinessProfile";
import { useContext } from "react";
import { SearchContext } from "../../pages/Search";
import { Button } from "../../components/ui/button";

export default function SearchSuggestions() {
  const { setSearchTerm } = useContext(SearchContext);
  const { data: profile, isLoading: isGetProfileLoading } =
    useGetBusinessProfile();

  const handleBoxClick = (example) => {
    setSearchTerm(example);
  };

  const searchExamples = profile?.search_queries?.length
    ? profile.search_queries
    : [
        "Simplified acquisition maintenance contracts",
        "Construction in New York",
        "Women-owned businesses",
        "Leasing opportunities",
      ];
  if (isGetProfileLoading) {
    return <ThemedSkeleton className="w-11/12" />;
  }

  return (
    <div id="search-example-box" className="flex flex-wrap gap-3">
      {searchExamples.map((example, index) => (
        <Button
          key={index}
          onClick={() => handleBoxClick(example)}
          variant="secondary"
          className=" text-muted-foreground"
        >
          {example}
        </Button>
      ))}
    </div>
  );
}
